import React from "react";

const EmptyLayout = ({ children }) => (
    <div style={{ minHeight: '100vh', backgroundColor: '#000' }}>
        { children }
    </div>
)

export default EmptyLayout